<template>
  <div class="medical-record__modal">
    <div class="modal__header">
      <div class="modal__info-group-1">
        <div class="info-group-1__item">
          <div class="info-group-1__img-profile">
            <img :src="photoFallback(recordData.patient.photo)" alt="" />
          </div>

          <div class="info-group__group">
            <div>
              <h6 class="info-group__title">
                {{ recordData.patient.name }}
              </h6>
            </div>
          </div>
        </div>

        <div class="info-group__line">&nbsp;</div>
        <div class="info-group-1__item">
          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">Telefone</h6>
            </div>
            <span>
              <p class="info-group__subtitle">
                {{ this.maskedPhoneNumber(recordData.patient.phone_number) }}
              </p>
            </span>
            <div>
              <h6 class="info-group__title-small">E-Mail</h6>
            </div>
            <span>
              <p class="info-group__subtitle">
                {{ recordData.patient.email }}
              </p>
            </span>
          </div>
        </div>

        <div class="info-group__line">&nbsp;</div>

        <div class="info-group-1__item">
          <div class="info-group__group">
            <sub>
              <h6 class="info-group__title-small">Observações</h6>
            </sub>
            <span>
              <p class="info-group__subtitle">
                {{ recordData.observation || "Nenhuma observação" }}
              </p>
            </span>
          </div>
        </div>
      </div>

      <hr />

      <div>
        <PatientRecordNotesHistory :patient-id="recordData.patient.id">
          <template #title>
            <h4>Histórico de Atendimentos</h4>
          </template>
        </PatientRecordNotesHistory>
      </div>

      <!-- <div class="modal__info-group-2">
        <div class="info-group-2__item">
          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">Última consulta</h6>
            </div>

            <span class="info-group__subtitle">20 de Novembro de 2020</span>
          </div>

          <div class="info-group__group">
            <div>
              <h6 class="info-group__title-small">
                Exames solicitados por você
              </h6>
            </div>

            <span class="info-group__subtitle"
              >Hemograma, Colesterol, Glicemia e Transaminases (ALT e AST) ou
              TPG TGO</span
            >
          </div>
        </div>

        <div class="info-group-2__item">
          <div class="info-group__group">
            <div class="info-group-2__clinical-data">
              <span class="clinical-data__title">OUTROS DADOS CLÍNICOS</span>
              <img src="../assets/images/arrow-down-icon.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
      <hr /> -->
    </div>
  </div>
</template>

<script>
import { authComputed, userMethods } from "../state/helpers";
import PatientRecordNotesHistory from "./PatientRecordNotesHistory.vue";
import { phoneMask } from "../utils/masks/phoneNumber";

export default {
  name: "MedicalRecord",
  components: {
    PatientRecordNotesHistory
  },
  props: { recordData: { type: Object, default: null } },
  methods: {
    ...userMethods,
    filteredSymptomsReports(report) {
      const newReportArray = [];
      for (let i = 1; i <= 31; i++) {
        let equals = null;
        report.map(item => {
          if (item.created_at == i) {
            equals = item;
          }
        });
        if (equals) {
          newReportArray.push(equals);
        } else {
          newReportArray.push({ created_at: `${i}`, intensity: "absent" });
        }
      }
      return newReportArray;
    },
    symptomIntensityClass(intensity) {
      let classStyle = "";
      switch (intensity) {
        case "low":
          classStyle = "low";
          break;
        case "middle":
          classStyle = "medium";
          break;
        case "hight":
          classStyle = "high";
          break;
        case "absent":
          classStyle = "absent";
          break;
      }
      return classStyle;
    },
    maskedPhoneNumber(input) {
      return phoneMask(input);
    },
    photoFallback(src) {
      return src || require("./../assets/images/doctor-img.jpg");
    }
  },
  computed: {
    ...authComputed
  }
};
</script>

<style lang="css" scoped>
.history_title {
  margin-bottom: 2rem;
  padding: 0px 20px;
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 16px;
  letter-spacing: 1px;
}
.medical-record__modal {
  font-family: "Inter", sans-serif;
  letter-spacing: -0.5px;
  font-style: normal;
}
/* INFO GROUP 1*/
.modal__info-group-1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.info-group-1__item:nth-child(1) {
  flex: 2;
  display: flex;
  align-items: center;
  padding: 0px;
  margin: 0px;
}
.info-group-1__item:nth-child(3) {
  flex: 1;
}
.info-group-1__item:nth-child(5) {
  flex: 2;
}
.info-group__line {
  border-right: solid 1px #dddddd;
  margin: 20px 0px;
}
@media (max-width: 1024px) {
  .modal__info-group-1 {
    flex-direction: column;
  }

  .info-group__line {
    border-right: none;
    border-bottom: solid 1px #dddddd;
  }
}
.info-group-1__img-profile img {
  width: 95px;
  height: 95px;
  border-radius: 8px;
}
.info-group__group {
  padding: 0.5em 2em;
}
.info-group__title {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 18px;
}
.info-group__title-small {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 16px;
}
.info-group__subtitle {
  font-weight: 500;
  font-size: 14px;
  color: #717171;
}
/* INFO GROUP 2 */
.modal__info-group-2 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.info-group-2__item:nth-child(1) {
  display: flex;
  align-items: center;
}
@media (max-width: 1024px) {
  .info-group-2__item:nth-child(1) {
    flex-wrap: wrap;
  }
}
.info-group-2__clinical-data {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.clinical-data__title {
  margin: 0;
  font-weight: 600;
  color: #222222;
  font-size: 14px;
  margin-right: 10px;
}
@media (max-width: 1024px) {
  .info-group-2__item:nth-child(2) {
    margin-top: 40px;
  }
}
</style>
